import { interceptor } from './../../services/interceptor';

import { Dispatch } from "redux";
import { API } from "../api/auth-api";
import * as types from '../types/auth-types'
import LoginModel from '../../models/login-model';
import FLUX_AUTH_CONSTANTS from "../constants/auth-constants";
import SignupModel from '../../models/signup-model';
import UserProfileModel from '../../models/userProfile-model';
import SHOPPING_CART_CONSTANTS from '../constants/shoppingCart-constants';

export const clearAuthLoading = (): types.IActionClearAuthLoading => {
    return {
        type: FLUX_AUTH_CONSTANTS.CLEAR_AUTH_LOADING
    }
}
//---------------------------------- LOGIN --------------------------------------------------

const loginBegin = (data: LoginModel): types.ILoginBegin => {
    return {
        type: FLUX_AUTH_CONSTANTS.LOGIN_BEGIN,
        data,
    }
}

const loginError = (e: any, data: any): types.ILoginError => {
    return {
        type: FLUX_AUTH_CONSTANTS.LOGIN_ERROR,
        error: e,
        data,
    }
}

const loginSuccess = (data: any): types.ILoginSuccess => {
    return {
        type: FLUX_AUTH_CONSTANTS.LOGIN_SUCCESS,
        data
    }
}

export const login = (data: LoginModel) => {
    return (dispatch: Dispatch) => {
        dispatch(loginBegin(data));
        API.login(data).then((response: any) => {
            localStorage.setItem('token', response.data.user.token);
            interceptor.addToken(response.data.user.token);
            dispatch(loginSuccess(response.data.user));
        }).catch((error: any) => {
            dispatch(loginError(error.response, data));
        });
    }
}


//---------------------------------- SIGHUP --------------------------------------------------

const signupBegin = (): types.ISignupBegin => {
    return {
        type: FLUX_AUTH_CONSTANTS.SIGNUP_BEGIN
    }
}

const signupError = (e: any): types.ISignupError => {
    return {
        type: FLUX_AUTH_CONSTANTS.SIGNUP_ERROR,
        error: e,
    }
}

const signupSuccess = (data: any): types.ISignupSuccess => {
    return {
        type: FLUX_AUTH_CONSTANTS.SIGNUP_SUCCESS,
        data
    }
}

export const signup = (data: SignupModel) => {
    return (dispatch: Dispatch) => {
        dispatch(signupBegin());
        API.signup(data).then((response: any) => {
            interceptor.addToken(response.data.user.token);
            localStorage.setItem('token', response.data.user.token);
            dispatch(signupSuccess(response.data.user));
        }).catch((error: any) => {
            dispatch(signupError(error.response));
        });
    }
}


//Logout

const logoutSuccess = (): types.ILogoutSuccess => {
    return {
        type: FLUX_AUTH_CONSTANTS.LOGOUT_SUCCESS,
    }
}
export const logout = () => {
    return (dispatch: Dispatch) => {
        dispatch(logoutSuccess());
        dispatch({ type: SHOPPING_CART_CONSTANTS.CART_RESET });
        localStorage.removeItem('cartItems');
        localStorage.removeItem('activestep');
        localStorage.removeItem('token');
        localStorage.removeItem('clientAddress');
    }
}


/////////////// Profile Info////////////////

const editProfileInfoBegin = (): types.IuserProfileBegin  => {
    return{
        type: FLUX_AUTH_CONSTANTS.EDIT_INFO_BEGIN,
    }
}


const editProfileInfoError = (e:any): types.IUserProfileError => {
    return {
        type: FLUX_AUTH_CONSTANTS.EDIT_INFO_ERROR,
        error:e
    }
}

const editProfileInfo = (data: any): types.IEditInfo => {
    return{
        type: FLUX_AUTH_CONSTANTS.EDIT_INFO,
        data
    }
}

export const profileInfo = (data: UserProfileModel ) => {
    return( dispatch: Dispatch) => {

        dispatch(editProfileInfoBegin());

        API.editInfo(data).then((response: any) => {
            dispatch(editProfileInfo(response.data.user));
        }).catch((error: any) => {
            dispatch(editProfileInfoError(error.response));
        });
    }
}